import React, { useEffect, useState } from 'react';
import Sidebar from '../../components/Sidebar';
import { useLanguage } from '../../contexts/LanguageContext';
import axios from 'axios';

const API = process.env.REACT_APP_BACKEND_URL;

export default function AdminUsers() {
  const { t } = useLanguage();
  const [users, setUsers] = useState<any[]>([]);

  useEffect(() => {
    axios.get(`${API}/api/admin/users`, { withCredentials: true }).then(r => setUsers(r.data)).catch(() => {});
  }, []);

  return (
    <div style={{ display: 'flex', minHeight: '100vh' }}>
      <Sidebar type="admin" active="users" />
      <main data-testid="admin-users-page" style={{ flex: 1, background: 'var(--bg-portal)', padding: 32 }}>
        <div style={{ maxWidth: 1200, margin: '0 auto' }}>
          <h1 style={{ fontFamily: 'var(--font-heading)', fontSize: 28, fontWeight: 700, marginBottom: 24 }}>{t('admin.users')}</h1>
          <div style={{ background: 'white', border: '1px solid var(--border)' }}>
            <div style={{ overflowX: 'auto' }}>
              <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                <thead>
                  <tr style={{ borderBottom: '1px solid var(--border)' }}>
                    {[t('auth.name'), t('auth.email'), t('auth.company'), 'Role', t('portal.date')].map(h => (
                      <th key={h} style={{ padding: '12px 20px', textAlign: 'left', fontSize: 12, fontWeight: 600, color: 'var(--text-muted)', textTransform: 'uppercase', letterSpacing: '0.1em' }}>{h}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {users.map(u => (
                    <tr key={u._id} style={{ borderBottom: '1px solid var(--border)' }}>
                      <td style={{ padding: '14px 20px', fontSize: 14, fontWeight: 500 }}>{u.name}</td>
                      <td style={{ padding: '14px 20px', fontSize: 14, color: 'var(--text-secondary)' }}>{u.email}</td>
                      <td style={{ padding: '14px 20px', fontSize: 14 }}>{u.company || '-'}</td>
                      <td style={{ padding: '14px 20px' }}>
                        <span style={{
                          padding: '4px 10px', fontSize: 11, fontWeight: 600, textTransform: 'uppercase',
                          background: u.role === 'admin' ? 'rgba(211,47,47,0.12)' : 'rgba(13,71,161,0.12)',
                          color: u.role === 'admin' ? 'var(--secondary)' : 'var(--primary)',
                        }}>{u.role}</span>
                      </td>
                      <td style={{ padding: '14px 20px', fontSize: 13, color: 'var(--text-muted)' }}>{u.created_at ? new Date(u.created_at).toLocaleDateString() : '-'}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
}
